import { useState } from 'react';
import { products } from '../../mocks/products';
import { useCart } from '../../context/CartContext';

export default function ProductsPage() {
  const { addToCart } = useCart();
  const [selectedCategory, setSelectedCategory] = useState<string>('Tous');
  const [addedToCart, setAddedToCart] = useState<string | null>(null);
  const [selectedVariants, setSelectedVariants] = useState<{ [key: string]: string }>({});
  const [lightboxProduct, setLightboxProduct] = useState<any>(null);
  const [parfumName, setParfumName] = useState<string>('');
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProduct, setNotificationProduct] = useState<string>('');

  const categories = ['Tous', 'Parfums', 'Corps et Hygiène', 'Soins du Visage', 'Soins Capillaires'];

  const filteredProducts =
    selectedCategory === 'Tous'
      ? products
      : products.filter((p) => p.category === selectedCategory);

  const handleCategoryChange = (category: string) => {
    setSelectedCategory(category);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleAddToCart = (product: any) => {
    const variant = selectedVariants[product.id];
    addToCart(product, variant);
    setAddedToCart(product.id);
    
    // Afficher la notification
    setNotificationProduct(product.name);
    setShowNotification(true);
    
    setTimeout(() => setAddedToCart(null), 2000);
    setTimeout(() => setShowNotification(false), 3000);
  };

  const getProductPrice = (product: any, variant?: string) => {
    if (!variant) return product.price;
    if (variant === '50ml') return product.price * 0.7;
    if (variant === '35ml') return product.price * 0.5;
    return product.price;
  };

  const getCategoryImages = (category: string) => {
    const categoryImages: { [key: string]: string[] } = {
      'Parfums': [
        'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/b2530c8aacf9b86c7fda7a416d4655c5.jpeg',
        'https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/cb72b4039a1e151189d216b36bc16c8f.jpeg'
      ],
    };
    return categoryImages[category] || [];
  };

  const handleParfumSearch = () => {
    if (parfumName.trim()) {
      const message = `Bonjour, je cherche l'équivalent de ce parfum : ${parfumName.trim()}`;
      const whatsappUrl = `https://wa.me/352621812568?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
      setParfumName('');
    }
  };

  const categoryImages = getCategoryImages(selectedCategory);

  return (
    <div className="min-h-screen pt-16 md:pt-20 bg-white">
      {/* Notification Pop-up */}
      {showNotification && (
        <div className="fixed top-24 right-4 z-50 animate-slide-in-right">
          <div className="bg-white rounded-xl shadow-2xl border-2 border-teal-600 p-4 flex items-center gap-3 max-w-sm">
            <div className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-check-line text-white text-xl w-5 h-5 flex items-center justify-center"></i>
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-gray-900">Produit ajouté !</p>
              <p className="text-xs text-gray-600 line-clamp-1">{notificationProduct}</p>
            </div>
            <button
              onClick={() => setShowNotification(false)}
              className="text-gray-400 hover:text-gray-600 cursor-pointer"
            >
              <i className="ri-close-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </button>
          </div>
        </div>
      )}

      {/* Header */}
      <section className="bg-gradient-to-br from-teal-600 to-teal-700 text-white py-8 md:py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2 md:mb-3 lg:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Nos Produits
          </h1>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/95 px-4">
            Découvrez notre collection complète de <strong>produits de beauté</strong>
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="bg-gray-50 py-3 md:py-4 lg:py-6 sticky top-16 md:top-20 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-start md:justify-center space-x-2 md:space-x-3 lg:space-x-4 overflow-x-auto pb-2 md:pb-0 scrollbar-hide">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => handleCategoryChange(category)}
                className={`px-3 sm:px-4 md:px-5 lg:px-6 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm md:text-base font-medium transition-all whitespace-nowrap cursor-pointer flex-shrink-0 ${
                  selectedCategory === category
                    ? 'bg-teal-600 text-white shadow-md'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Parfum Search Section */}
      {selectedCategory === 'Parfums' && (
        <section className="py-6 md:py-10 lg:py-12 bg-gradient-to-br from-teal-50 to-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-xl md:rounded-2xl shadow-lg p-4 sm:p-6 md:p-8">
              <div className="text-center mb-4 md:mb-6">
                <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                  <i className="ri-search-line text-2xl sm:text-3xl text-teal-600 w-6 sm:w-7 md:w-8 h-6 sm:h-7 md:h-8 flex items-center justify-center"></i>
                </div>
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-2 md:mb-3 px-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Trouvez votre équivalent
                </h2>
                <p className="text-sm sm:text-base md:text-lg text-gray-600 px-4">
                  Donne-moi le nom de ton parfum et je te dirai si j'ai ton équivalent
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
                <input
                  type="text"
                  value={parfumName}
                  onChange={(e) => setParfumName(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleParfumSearch()}
                  placeholder="Ex: Chanel N°5, Dior Sauvage..."
                  className="flex-1 px-3 sm:px-4 md:px-6 py-2.5 sm:py-3 md:py-4 rounded-lg border-2 border-gray-200 focus:border-teal-600 focus:outline-none text-sm md:text-base text-gray-900 placeholder-gray-400"
                />
                <button
                  onClick={handleParfumSearch}
                  disabled={!parfumName.trim()}
                  className="bg-teal-600 hover:bg-teal-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-4 sm:px-6 md:px-8 py-2.5 sm:py-3 md:py-4 rounded-lg text-sm md:text-base font-medium transition-all whitespace-nowrap cursor-pointer flex items-center justify-center space-x-2 shadow-md"
                >
                  <i className="ri-whatsapp-line text-lg sm:text-xl md:text-2xl w-4 sm:w-5 md:w-6 h-4 sm:h-5 md:h-6 flex items-center justify-center"></i>
                  <span>Rechercher</span>
                </button>
              </div>
              
              <p className="text-xs md:text-sm text-gray-500 text-center mt-3 md:mt-4">
                Votre demande sera envoyée directement via WhatsApp
              </p>
            </div>
          </div>
        </section>
      )}

      {/* Category Cover Images */}
      {categoryImages.length > 0 && (
        <section className="py-6 md:py-10 lg:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-2 gap-3 md:gap-4 lg:gap-6">
              {categoryImages.map((image, index) => (
                <div key={index} className="w-full h-32 sm:h-40 md:h-48 lg:h-56 rounded-xl md:rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src={image}
                    alt={`${selectedCategory} ${index + 1}`}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Products Grid */}
      <section className="py-6 md:py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 lg:gap-8" data-product-shop>
            {filteredProducts.map((product) => {
              const selectedVariant = selectedVariants[product.id];
              const displayPrice = getProductPrice(product, selectedVariant);

              return (
                <div
                  key={product.id}
                  className="bg-gray-50 rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all"
                >
                  <div 
                    className="w-full h-48 sm:h-56 md:h-64 lg:h-72 overflow-hidden cursor-pointer"
                    onClick={() => setLightboxProduct(product)}
                  >
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-3 sm:p-4 md:p-5">
                    <span className="text-xs font-medium text-teal-600 bg-teal-50 px-2 md:px-3 py-1 rounded-full">
                      {product.category}
                    </span>
                    <h3 className="text-sm sm:text-base md:text-lg font-semibold text-gray-900 mt-2 mb-1 md:mb-2">
                      {product.name}
                    </h3>
                    <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-4 line-clamp-2">
                      {product.description}
                    </p>

                    {product.variants && (
                      <div className="mb-3 md:mb-4">
                        <label className="text-xs font-medium text-gray-700 mb-2 block">
                          Taille:
                        </label>
                        <div className="flex flex-wrap gap-1.5 md:gap-2">
                          {product.variants.map((variant) => (
                            <button
                              key={variant}
                              onClick={() =>
                                setSelectedVariants({
                                  ...selectedVariants,
                                  [product.id]: variant,
                                })
                              }
                              className={`px-2 sm:px-3 py-1 rounded-md text-xs font-medium transition-all whitespace-nowrap cursor-pointer ${
                                selectedVariant === variant
                                  ? 'bg-teal-600 text-white'
                                  : 'bg-white text-gray-700 border border-gray-300 hover:border-teal-600'
                              }`}
                            >
                              {variant}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="flex items-center justify-between gap-2">
                      <span className="text-lg sm:text-xl md:text-2xl font-bold text-teal-600">
                        €{displayPrice.toFixed(2)}
                      </span>
                      <button
                        onClick={() => handleAddToCart(product)}
                        className={`px-2.5 sm:px-3 md:px-4 py-1.5 sm:py-2 rounded-lg text-xs md:text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                          addedToCart === product.id
                            ? 'bg-green-600 text-white'
                            : 'bg-teal-600 hover:bg-teal-700 text-white'
                        }`}
                      >
                        {addedToCart === product.id ? (
                          <span className="flex items-center space-x-1">
                            <i className="ri-check-line w-3.5 sm:w-4 h-3.5 sm:h-4 flex items-center justify-center"></i>
                            <span className="hidden sm:inline">Ajouté</span>
                          </span>
                        ) : (
                          <span className="flex items-center space-x-1">
                            <i className="ri-shopping-cart-line w-3.5 sm:w-4 h-3.5 sm:h-4 flex items-center justify-center"></i>
                            <span className="hidden sm:inline">Ajouter</span>
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxProduct && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-3 sm:p-4 cursor-pointer overflow-y-auto"
          onClick={() => setLightboxProduct(null)}
        >
          <button
            onClick={() => setLightboxProduct(null)}
            className="absolute top-2 right-2 sm:top-4 sm:right-4 text-white hover:text-gray-300 transition-colors cursor-pointer z-10"
          >
            <i className="ri-close-line text-3xl sm:text-4xl w-8 sm:w-10 h-8 sm:h-10 flex items-center justify-center"></i>
          </button>
          <div 
            className="bg-white rounded-xl md:rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto cursor-default"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="grid md:grid-cols-2 gap-4 sm:gap-6 p-4 sm:p-6 md:p-8">
              {/* Image */}
              <div className="w-full h-56 sm:h-64 md:h-96 rounded-lg md:rounded-xl overflow-hidden">
                <img
                  src={lightboxProduct.image}
                  alt={lightboxProduct.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              {/* Product Details */}
              <div className="flex flex-col justify-center">
                <span className="text-xs font-medium text-teal-600 bg-teal-50 px-2 sm:px-3 py-1 rounded-full inline-block w-fit mb-2 sm:mb-3">
                  {lightboxProduct.category}
                </span>
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
                  {lightboxProduct.name}
                </h2>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4 sm:mb-6">
                  {lightboxProduct.description}
                </p>
                <div className="text-2xl sm:text-3xl font-bold text-teal-600 mb-4 sm:mb-6">
                  €{lightboxProduct.price.toFixed(2)}
                </div>
                
                {lightboxProduct.variants && (
                  <div className="mb-4 sm:mb-6">
                    <label className="text-xs sm:text-sm font-medium text-gray-700 mb-2 sm:mb-3 block">
                      Taille disponible:
                    </label>
                    <div className="flex flex-wrap gap-2">
                      {lightboxProduct.variants.map((variant: string) => (
                        <span
                          key={variant}
                          className="px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-medium bg-gray-100 text-gray-700 border border-gray-300"
                        >
                          {variant}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                
                <button
                  onClick={() => {
                    handleAddToCart(lightboxProduct);
                    setLightboxProduct(null);
                  }}
                  className="w-full bg-teal-600 hover:bg-teal-700 text-white px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg text-sm sm:text-base font-medium transition-all whitespace-nowrap cursor-pointer flex items-center justify-center space-x-2"
                >
                  <i className="ri-shopping-cart-line w-4 sm:w-5 h-4 sm:h-5 flex items-center justify-center"></i>
                  <span>Ajouter au panier</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
